import * as React from "react";
import './SvgProgramming.scss';  
const SvgProgramming = () => (
  <svg
    className="animated"
    id="freepik_stories-pair-programming"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 500 500" 
  >
    <g
      id="freepik--background-simple--inject-392"
      className="animable"
      style={{
        transformOrigin: "248.509px 230.74px",
      }}
    >
      <path
        d="M86.26,358.2C60.65,321.76,2.07,215.13,120.15,183.27S200.43,60.4,286.69,61.74s170.92,73.59,160.52,142.15S342.16,267,315.7,337.83,131.32,422.3,86.26,358.2Z"
        style={{
          fill: "#E32531",
          transformOrigin: "248.509px 230.569px",
        }}
        id="elwojylzfptq"
        className="animable"
      />
      <g id="ely4mpy0i24v">
        <path
          d="M86.26,358.55C60.65,322.11,2.07,215.48,120.15,183.62S200.43,60.75,286.69,62.08s170.92,73.6,160.52,142.16-105,63.11-131.51,133.93S131.32,422.65,86.26,358.55Z"
          style={{
            fill: "rgb(255, 255, 255)",
            opacity: 0.7,
            transformOrigin: "248.509px 230.91px",
          }}
          className="animable"
          id="elanraa78kuh9"
        />
      </g>
    </g>
    <g
      id="freepik--Graphics--inject-392"
      className="animable animator-hidden"
      style={{
        transformOrigin: "261.837px 228.8px",
      }}
    >
      <path
        d="M380.52,194.16a21.9,21.9,0,0,0,11-6.38l7.05,2.39,3.51-6.09-5.58-4.91a22.05,22.05,0,0,0,0-12.74l5.58-4.91-3.51-6.1-7.05,2.39a21.81,21.81,0,0,0-11-6.37l-1.46-7.3h-3.52"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeMiterlimit: 10,
          transformOrigin: "388.81px 169.15px",
        }}
        id="elrkb4ns2kzk"
        className="animable"
      />
      <path
        d="M372,144.14l-1.46,7.3a21.85,21.85,0,0,0-11,6.37l-7-2.39-3.51,6.1,5.58,4.91a22.05,22.05,0,0,0,0,12.74L349,184.08l3.51,6.09,7-2.39a21.94,21.94,0,0,0,11,6.38l1.46,7.29h7l1.46-7.29"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeMiterlimit: 10,
          transformOrigin: "364.715px 172.795px",
        }}
        id="elfoteofcj7mv"
        className="animable"
      />
      <path
        d="M375.09,184.53c-12.54-.88-14.89-19.14-2.36-22.35"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeMiterlimit: 10,
          transformOrigin: "369.758px 173.355px",
        }}
        id="elkpgr41iuigg"
        className="animable"
      />
      <path
        d="M383,164.7c6.24,5.71,4.27,16.87-4,19.39"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeMiterlimit: 10,
          transformOrigin: "382.835px 174.395px",
        }}
        id="elteowyf33ktg"
        className="animable"
      />
      <path
        d="M377,161.93a10.92,10.92,0,0,1,3.16.87"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeMiterlimit: 10,
          transformOrigin: "378.58px 162.365px",
        }}
        id="elq6u6yuqnwv"
        className="animable"
      />
      <path
        d="M417.88,199.71l1.48-1.77a14.55,14.55,0,0,0,8.39-.21l3.32,3.59"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeMiterlimit: 10,
          transformOrigin: "424.475px 199.525px",
        }}
        id="el0twz0k2iol2e"
        className="animable"
      />
      <path
        d="M412.41,172l.65,1.75a14.47,14.47,0,0,0-4,7.37l-4.77,1.09.11,4.63,4.83.84a14.59,14.59,0,0,0,1.66,3.9,14.33,14.33,0,0,0,2.72,3.25l-1.45,4.68,4.07,2.21"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeMiterlimit: 10,
          transformOrigin: "410.26px 186.86px",
        }}
        id="eljsf5ltle8ta"
        className="animable"
      />
      <path
        d="M431.07,201.32,435,198.9l-1.68-4.6a14.53,14.53,0,0,0,4-7.37l4.77-1.08-.12-4.63-4.82-.84a14.45,14.45,0,0,0-4.38-7.15l1.45-4.68-4.07-2.21L427,170.1a14.35,14.35,0,0,0-8.38.21l-3.33-3.59-3.95,2.42"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeMiterlimit: 10,
          transformOrigin: "426.715px 183.83px",
        }}
        id="elm4x9paehsfb"
        className="animable"
      />
      <path
        d="M430.48,182.32c1.37,5.74-4.09,11.27-9.86,8.94-5.5-2.23-6.3-10.3-1.19-13.4"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeMiterlimit: 10,
          transformOrigin: "423.352px 184.833px",
        }}
        id="elj2mlzbqv5sm"
        className="animable"
      />
      <path
        d="M425.76,177.16a7.37,7.37,0,0,1,3,2"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeMiterlimit: 10,
          transformOrigin: "427.26px 178.16px",
        }}
        id="elikq2m81t8n"
        className="animable"
      />
      <path
        d="M108.82,296l7.52,7.51a8.08,8.08,0,0,0,9.73,9.73l-4.72-4.71,1.28-4.78,4.77-1.28,4.72,4.72a8.08,8.08,0,0,0-9.73-9.73l-6.92-6.92"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeMiterlimit: 10,
          transformOrigin: "120.58px 302px",
        }}
        id="elasqrwe91b25"
        className="animable"
      />
      <path
        d="M104.48,279.58l-6.89-6.89A8.1,8.1,0,0,0,87.85,263l4.72,4.72-1.28,4.77-4.77,1.28L81.8,269a8.1,8.1,0,0,0,9.74,9.74l6.89,6.89"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeMiterlimit: 10,
          transformOrigin: "93.0323px 274.209px",
        }}
        id="elieaeqt5g38"
        className="animable"
      />
      <path
        d="M112.22,286.83l9.61-9.61a6.68,6.68,0,0,1,1.61-1.18l1.93-1,7-8L128,262.74l-8,7-1,1.93a6.25,6.25,0,0,1-1.18,1.61l-7.62,7.63"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeMiterlimit: 10,
          transformOrigin: "121.285px 274.785px",
        }}
        id="elxfyelmz1c9"
        className="animable"
      />
      <path
        d="M86.64,312a3.26,3.26,0,0,0,4.18-.58l16.65-16.65a3.16,3.16,0,0,0,1-2.89l2.89-2.89.18.17a1.06,1.06,0,0,0,1.51,0,1.08,1.08,0,0,0,0-1.51l-5.7-5.7a1.07,1.07,0,0,0-1.51,1.52l.18.17-2.89,2.89a3.15,3.15,0,0,0-2.89,1L83.61,304.25A3.22,3.22,0,0,0,82.55,307"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeMiterlimit: 10,
          transformOrigin: "97.9446px 297.074px",
        }}
        id="eluia95trlune"
        className="animable"
      />
      <path
        d="M83.22,308.76a9.25,9.25,0,0,0,1.38,1.71,8.72,8.72,0,0,0,2,1.57"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeMiterlimit: 10,
          transformOrigin: "84.91px 310.4px",
        }}
        id="eli2y01nlkpb"
        className="animable"
      />
      <line
        x1={88.34}
        y1={306.99}
        x2={91.25}
        y2={304.08}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeMiterlimit: 10,
          transformOrigin: "89.795px 305.535px",
        }}
        id="eliruz3in3u"
        className="animable"
      />
      <line
        x1={95.18}
        y1={300.15}
        x2={107.48}
        y2={287.59}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeMiterlimit: 10,
          transformOrigin: "101.33px 293.87px",
        }}
        id="el0zbw8vk7s4jn"
        className="animable"
      />
    </g>
    <g
      id="freepik--Coding--inject-392"
      className="animable"
      style={{
        transformOrigin: "230.26px 174.36px",
      }}
    >
      <rect
        x={96.96}
        y={87.76}
        width={266.6}
        height={173.2}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "230.26px 174.36px",
        }}
        id="elhzovjn53q8b"
        className="animable"
      />
      <polygon
        points="363.56 87.76 96.96 87.76 96.96 260.96 125.15 260.96 169.84 260.96 363.56 260.96 363.56 87.76"
        style={{
          fill: "rgb(191, 191, 191)",
          transformOrigin: "230.26px 174.36px",
        }}
        id="elhxoyu0fsd5l"
        className="animable"
      />
      <rect
        x={96.96}
        y={87.76}
        width={266.6}
        height={22.66}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "230.26px 99.09px",
        }}
        id="eljvggiim6wec"
        className="animable"
      />
      <rect
        x={96.96}
        y={87.76}
        width={266.6}
        height={22.66}
        style={{
          fill: "rgb(117, 117, 117)",
          transformOrigin: "230.26px 99.09px",
        }}
        id="elqpo75ydilj"
        className="animable"
      />
      <rect
        x={342.57}
        y={91.37}
        width={15.44}
        height={15.44}
        rx={2.62}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "350.29px 99.09px",
        }}
        id="el5elo2mkr4a7"
        className="animable"
      />
      <rect
        x={323.65}
        y={91.37}
        width={15.44}
        height={15.44}
        rx={2.64}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "331.37px 99.09px",
        }}
        id="elgrvwi3ctwd7"
        className="animable"
      />
      <rect
        x={304.73}
        y={91.37}
        width={15.44}
        height={15.44}
        rx={2.62}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "312.45px 99.09px",
        }}
        id="elxq2czebiwdd"
        className="animable"
      />
      <rect
        x={106.96}
        y={120.42}
        width={246.6}
        height={130.54}
        rx={5.22}
        style={{
          fill: "rgb(38, 50, 56)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "230.26px 185.69px",
        }}
        id="el8tr06zwzdxg"
        className="animable"
      />
      <line
        x1={346.98}
        y1={102.4}
        x2={353.6}
        y2={95.78}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "350.29px 99.09px",
        }}
        id="elzkv7433u5ej"
        className="animable"
      />
      <line
        x1={346.98}
        y1={95.78}
        x2={353.6}
        y2={102.4}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "350.29px 99.09px",
        }}
        id="elpafc2zos6ub"
        className="animable"
      />
      <rect
        x={326.95}
        y={97.67}
        width={8.83}
        height={5.83}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "331.365px 100.585px",
        }}
        id="elb0xymgot3bf"
        className="animable"
      />
      <line
        x1={316.86}
        y1={103.5}
        x2={308.03}
        y2={103.5}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "312.445px 103.5px",
        }}
        id="el78wzy7n6v8k"
        className="animable"
      />
      <path
        d="M338.06,209.16H320.53a2,2,0,0,1,0-4h17.53a2,2,0,0,1,0,4Z"
        style={{
          fill: "rgb(117, 117, 117)",
          transformOrigin: "329.295px 207.16px",
        }}
        id="elwjgz3dpa6rc"
        className="animable"
      />
      <path
        d="M338.06,223H289.13a2,2,0,0,1,0-4h48.93a2,2,0,0,1,0,4Z"
        style={{
          fill: "rgb(117, 117, 117)",
          transformOrigin: "313.595px 221px",
        }}
        id="el8abhg3qahf2"
        className="animable"
      />
      <path
        d="M338.06,236.83H230.26a2,2,0,0,1,0-4h107.8a2,2,0,0,1,0,4Z"
        style={{
          fill: "rgb(117, 117, 117)",
          transformOrigin: "284.16px 234.83px",
        }}
        id="elxi5hphfqv5n"
        className="animable"
      />
      <path
        d="M125.46,195.33h-8.17a2,2,0,1,1,0-4h8.17a2,2,0,1,1,0,4Z"
        style={{
          fill: "rgb(191, 191, 191)",
          transformOrigin: "121.375px 193.33px",
        }}
        id="elzhkdhifkw9s"
        className="animable"
      />
      <path
        d="M125.46,209.16h-8.17a2,2,0,1,1,0-4h8.17a2,2,0,1,1,0,4Z"
        style={{
          fill: "rgb(191, 191, 191)",
          transformOrigin: "121.375px 207.16px",
        }}
        id="elogqhqvlu2al"
        className="animable"
      />
      <path
        d="M125.46,223h-8.17a2,2,0,0,1,0-4h8.17a2,2,0,0,1,0,4Z"
        style={{
          fill: "rgb(191, 191, 191)",
          transformOrigin: "121.375px 221px",
        }}
        id="elnn7x8wsvvd"
        className="animable"
      />
      <path
        d="M125.46,236.83h-8.17a2,2,0,1,1,0-4h8.17a2,2,0,1,1,0,4Z"
        style={{
          fill: "rgb(191, 191, 191)",
          transformOrigin: "121.375px 234.83px",
        }}
        id="eli5ftnkr23xm"
        className="animable"
      />
      <g id="eliv08nrlun3q">
        <g
          style={{
            opacity: 0.7,
            transformOrigin: "121.375px 193.33px",
          }}
          className="animable"
          id="el3mh313p5o44"
        >
          <path
            d="M125.46,195.33h-8.17a2,2,0,1,1,0-4h8.17a2,2,0,1,1,0,4Z"
            style={{
              fill: "rgb(191, 191, 191)",
              transformOrigin: "121.375px 193.33px",
            }}
            id="elrekgndz8ohi"
            className="animable"
          />
        </g>
      </g>
      <g id="ely8hewe72phj">
        <g
          style={{
            opacity: 0.7,
            transformOrigin: "121.375px 207.16px",
          }}
          className="animable"
          id="eldzfsj1xhnh"
        >
          <path
            d="M125.46,209.16h-8.17a2,2,0,1,1,0-4h8.17a2,2,0,1,1,0,4Z"
            style={{
              fill: "rgb(191, 191, 191)",
              transformOrigin: "121.375px 207.16px",
            }}
            id="eldjle6zswz4l"
            className="animable"
          />
        </g>
      </g>
      <g id="el5awpzzkbgqx">
        <g
          style={{
            opacity: 0.7,
            transformOrigin: "121.375px 221px",
          }}
          className="animable"
          id="el6i3i93qqrcg"
        >
          <path
            d="M125.46,223h-8.17a2,2,0,0,1,0-4h8.17a2,2,0,0,1,0,4Z"
            style={{
              fill: "rgb(191, 191, 191)",
              transformOrigin: "121.375px 221px",
            }}
            id="elez01pl3yvc"
            className="animable"
          />
        </g>
      </g>
      <g id="eldie80jajkra">
        <g
          style={{
            opacity: 0.7,
            transformOrigin: "121.375px 234.83px",
          }}
          className="animable"
          id="ele7ilj2ndl3c"
        >
          <path
            d="M125.46,236.83h-8.17a2,2,0,1,1,0-4h8.17a2,2,0,1,1,0,4Z"
            style={{
              fill: "rgb(191, 191, 191)",
              transformOrigin: "121.375px 234.83px",
            }}
            id="elewlm1i42a0n"
            className="animable"
          />
        </g>
      </g>
      <path
        d="M289.13,181.49H117.29a2,2,0,0,1,0-4H289.13a2,2,0,0,1,0,4Z"
        style={{
          fill: "rgb(191, 191, 191)",
          transformOrigin: "203.21px 179.49px",
        }}
        id="el1s9wr9blmltj"
        className="animable"
      />
      <path
        d="M338.06,153.83H320.53a2,2,0,0,1,0-4h17.53a2,2,0,0,1,0,4Z"
        style={{
          fill: "rgb(191, 191, 191)",
          transformOrigin: "329.295px 151.83px",
        }}
        id="els365l1o7szd"
        className="animable"
      />
      <path
        d="M313.2,153.83H296.46a2,2,0,0,1,0-4H313.2a2,2,0,0,1,0,4Z"
        style={{
          fill: "rgb(191, 191, 191)",
          transformOrigin: "304.83px 151.83px",
        }}
        id="elknjabfg279"
        className="animable"
      />
      <path
        d="M289.13,153.83H117.29a2,2,0,1,1,0-4H289.13a2,2,0,0,1,0,4Z"
        style={{
          fill: "rgb(191, 191, 191)",
          transformOrigin: "203.21px 151.83px",
        }}
        id="ellz27h27qgvg"
        className="animable"
      />
      <path
        d="M338.06,195.33H320.53a2,2,0,0,1,0-4h17.53a2,2,0,0,1,0,4Z"
        style={{
          fill: "rgb(153, 153, 153)",
          transformOrigin: "329.295px 193.33px",
        }}
        id="elikz8rv28gq"
        className="animable"
      />
      <path
        d="M313.2,195.33H134.46a2,2,0,0,1,0-4H313.2a2,2,0,0,1,0,4Z"
        style={{
          fill: "rgb(153, 153, 153)",
          transformOrigin: "223.83px 193.33px",
        }}
        id="elzd4xcvloan"
        className="animable"
      />
      <path
        d="M185.79,209.16H134.46a2,2,0,0,1,0-4h51.33a2,2,0,0,1,0,4Z"
        style={{
          fill: "rgb(153, 153, 153)",
          transformOrigin: "160.125px 207.16px",
        }}
        id="el54icz3a6in4"
        className="animable"
      />
      <path
        d="M185.79,223H134.46a2,2,0,0,1,0-4h51.33a2,2,0,0,1,0,4Z"
        style={{
          fill: "rgb(153, 153, 153)",
          transformOrigin: "160.125px 221px",
        }}
        id="elsbugyf0enuh"
        className="animable"
      />
      <path
        d="M185.79,236.83H134.46a2,2,0,0,1,0-4h51.33a2,2,0,0,1,0,4Z"
        style={{
          fill: "rgb(153, 153, 153)",
          transformOrigin: "160.125px 234.83px",
        }}
        id="elifj3dxt8dup"
        className="animable"
      />
    </g>
    <g
      id="freepik--character-1--inject-392"
      className="animable"
      style={{
        transformOrigin: "226px 340.58px",
      }}
    >
      <path
        d="M152.08,414.24s-5.24,9-3.18,9.35,6.39-7.48,6.39-7.48L167.14,413l-8.93-.92Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "157.78px 417.841px",
        }}
        id="elwj6fhajx8f"
        className="animable"
      />
      <g id="eld43rqejtdeb">
        <path
          d="M152.08,414.24s-5.24,9-3.18,9.35,6.39-7.48,6.39-7.48L167.14,413l-8.93-.92Z"
          style={{
            stroke: "rgb(38, 50, 56)",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            opacity: 0.3,
            transformOrigin: "157.78px 417.841px",
          }}
          className="animable"
          id="elvsu2dbq2b1f"
        />
      </g>
      <path
        d="M156.07,408.08s-7.34-1.74-9.36,1.7-8,13.65-5.74,14.81,4.17-2.6,4.17-2.6Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "148.269px 416.226px",
        }}
        id="elzdzphbzlusm"
        className="animable"
      />
      <path
        d="M186.09,418.54a33.39,33.39,0,0,1-15,1.58l-8.35,2.78s-7.34,3.61-10.76,1.79,8.7-5.84,8.7-5.84,8.15-3.53,5.72-4.38-11.63-.68-13.43.7-6.55,10.37-10,9.85,1.44-5.4,2.67-7.28,4-9.38,9.56-9.7,24.37.65,24.37.65l22.09-2.36,5.21,12.57Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "174.314px 415.766px",
        }}
        id="elsyfu1pnl5vo"
        className="animable"
      />
      <path
        d="M197.62,421.65a3.54,3.54,0,0,0,4.21-.06,3.68,3.68,0,0,0,4-.74c1.61-1.77,1.75-17.3-2.71-19.05-1.29-.5-4.51-.45-5,1.35a2.36,2.36,0,0,0-3.24,2c-.44,2.8,2.34,5.41,1.41,13.46A3.17,3.17,0,0,0,197.62,421.65Z"
        style={{
          fill: "#E32531",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "200.845px 411.921px",
        }}
        id="elq7d31tli1cc"
        className="animable"
      />
      <g id="ell2c8gp4melh">
        <path
          d="M197.62,421.65a3.54,3.54,0,0,0,4.21-.06,3.68,3.68,0,0,0,4-.74c1.61-1.77,1.75-17.3-2.71-19.05-1.29-.5-4.51-.45-5,1.35a2.36,2.36,0,0,0-3.24,2c-.44,2.8,2.34,5.41,1.41,13.46A3.17,3.17,0,0,0,197.62,421.65Z"
          style={{
            stroke: "rgb(38, 50, 56)",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            opacity: 0.3,
            transformOrigin: "200.845px 411.921px",
          }}
          className="animable"
          id="elkbwp9pobf6"
        />
      </g>
      <path
        d="M202.72,418a30,30,0,0,0-2.64-12.27"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "201.4px 411.865px",
        }}
        id="elwwbtirp90j"
        className="animable"
      />
      <path
        d="M307.85,412.39c-.74,5.69-1.58,11.85-2.54,18.54H219.47l.41-11.06c-5.13,1.24-15.1.48-15.1.48V404c6.06-3.43,7-2.47,7-2.47s.31-39.9,3.94-49.86a20.09,20.09,0,0,1,7.1-9.34h0a24.31,24.31,0,0,1,2.71-1.75l.13-.08c1-.53,2.21-1.09,3.59-1.67l.38-.15c13.44-5.49,42.77-11.86,70.1-.18,1.91.82,17.51,8.27,18.84,19C319.29,363.67,315.11,394.21,307.85,412.39Z"
        style={{
          fill: "#E32531",
          transformOrigin: "261.715px 381.431px",
        }}
        id="elxa7zdygzd3a"
        className="animable"
      />
      <g
        style={{
          clipPath: "url(&quot",
          transformOrigin: "257.33px 396.005px",
        }}
        id="el8n4wn29qiuq"
        className="animable"
      >
        <g id="elt33xtaq9898">
          <path
            d="M294.25,363.2l-8.56,39.73c-1.33-1.05-5.16-1.12-10-.66a15.66,15.66,0,0,0,2.59-3.88C291.19,370.39,294,363.76,294.25,363.2Z"
            style={{
              opacity: 0.2,
              transformOrigin: "284.97px 383.065px",
            }}
            className="animable"
            id="el5kigrfj9j4s"
          />
        </g>
        <g id="el9z4d2usuor4">
          <path
            d="M309.89,406.85a176,176,0,0,0-4.58,24.08H219.47l.79-12.74c5.35-.76,14.74-1.54,24.49-3.27a21.76,21.76,0,0,1,.23,9.31s39.48,4.9,52.73,1.71c3.78-.91,7.2-6.19,10.13-13.46C308.55,410.71,309.23,408.82,309.89,406.85Z"
            style={{
              opacity: 0.2,
              transformOrigin: "264.68px 418.89px",
            }}
            className="animable"
            id="elh07hn71pec6"
          />
        </g>
        <g id="elc5subivtok7">
          <path
            d="M212.77,402.28s-1.93-1.71-8,1.72v16.35s10-.35,13.92-2.48c3.38,2.09,2.78-36.18,3.38-56.79-4.9,1.35-5.29,10.67-6.05,19.44A175.71,175.71,0,0,1,212.77,402.28Z"
            style={{
              opacity: 0.3,
              transformOrigin: "213.42px 390.715px",
            }}
            className="animable"
            id="el4glalaymed3"
          />
        </g>
      </g>
      <path
        d="M307.85,412.39c-.74,5.69-1.58,11.85-2.54,18.54H219.47l.41-11.06c-5.13,1.24-15.1.48-15.1.48V404c6.06-3.43,7-2.47,7-2.47s.31-39.9,3.94-49.86a20.09,20.09,0,0,1,7.1-9.34h0a24.31,24.31,0,0,1,2.71-1.75l.13-.08c1-.53,2.21-1.09,3.59-1.67l.38-.15c13.44-5.49,42.77-11.86,70.1-.18,1.91.82,17.51,8.27,18.84,19C319.29,363.67,315.11,394.21,307.85,412.39Z"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "261.715px 381.431px",
        }}
        id="ele3rgwi52v17"
        className="animable"
      />
      <path
        d="M318.53,357.53c0,.24.06.52.07.83.44,7.68-3.74,36.66-10.76,54.12-2.93,7.27-6.35,12.55-10.13,13.46-13.25,3.19-52.73-1.71-52.73-1.71a21.88,21.88,0,0,0-2.95-15.7s38.76-9.48,43.66-5.6l8.58-39.77"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "280.331px 392.274px",
        }}
        id="elkkf7tln29q"
        className="animable"
      />
      <path
        d="M288.39,405.1a17.6,17.6,0,0,1,6.87,5.88"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "291.825px 408.04px",
        }}
        id="elksnsth8uegq"
        className="animable"
      />
      <path
        d="M189.65,406.52s-3.62-.76-5.09.89-7.77,11.11-5.64,12.91,6.46-8.09,6.46-8.09Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "184.067px 413.442px",
        }}
        id="elcschz26lnhm"
        className="animable"
      />
      <path
        d="M196.91,406.35s-8-1.72-9.83.73-11.92,15.13-5.62,15.53l10-11.28Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "188.162px 414.187px",
        }}
        id="eled3bsa1jj5b"
        className="animable"
      />
      <path
        d="M215.05,419.83s-8.25,1.8-11.6,2.46-9.57,5-13.25,3.27,12-8.1,12-8.1l5.4-2.17Z"
        style={{
          fill: "rgb(191, 191, 191)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "202.345px 420.627px",
        }}
        id="el8zm4fsyrek8"
        className="animable"
      />
      <path
        d="M221.73,370.47c.12-3.13.23-6.26.35-9.39"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "221.905px 365.775px",
        }}
        id="elrf3fdwp6h4i"
        className="animable"
      />
      <path
        d="M219.47,430.93c1.53-18.93,2.1-56.2,2.1-56.2"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "220.52px 402.83px",
        }}
        id="elj55pgclir6h"
        className="animable"
      />
      <path
        d="M245,409.62H216.53s-22.08-6.63-25.75-1.48-11.53,13-9.32,14.47S193,413.42,193,413.42l8.1.07s-6.87,3-8.34,4.46-4.66,5.64-3,6.38,7.12-4.66,7.12-4.66,8.09-2,10.05-1a27.92,27.92,0,0,0,20.36,2l21.71,2.7Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "215.037px 415.29px",
        }}
        id="elcxz4cifolkl"
        className="animable"
      />
      <path
        d="M291.3,376.93a42.14,42.14,0,0,1-.09-13.77"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "290.994px 370.045px",
        }}
        id="elefd3iazp18f"
        className="animable"
      />
      <path
        d="M297.75,353.08s13.8-18.18,20.78,4.45"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "308.14px 351.852px",
        }}
        id="elefk5izillpe"
        className="animable"
      />
      <path
        d="M239.14,407.37a3.57,3.57,0,0,1,4.1-1,3.67,3.67,0,0,1,4.06-.28c2,1.32,6,16.32,2.11,19.13-1.12.8-4.25,1.55-5.21-.06a2.37,2.37,0,0,1-3.65-1.15c-1.12-2.61.93-5.82-2-13.39A3.19,3.19,0,0,1,239.14,407.37Z"
        style={{
          fill: "#E32531",
          transformOrigin: "244.694px 415.859px",
        }}
        id="el6yynty7arut"
        className="animable"
      />
      <g
        style={{
          clipPath: "url(&quot",
          transformOrigin: "244.694px 415.859px",
        }}
        id="elngu6timapul"
        className="animable"
      >
        <g id="ely8mz267zu2">
          <path
            d="M239.14,407.37a3.57,3.57,0,0,1,4.1-1,3.67,3.67,0,0,1,4.06-.28c2,1.32,6,16.32,2.11,19.13-1.12.8-4.25,1.55-5.21-.06a2.37,2.37,0,0,1-3.65-1.15c-1.12-2.61.93-5.82-2-13.39A3.19,3.19,0,0,1,239.14,407.37Z"
            style={{
              opacity: 0.3,
              transformOrigin: "244.694px 415.859px",
            }}
            className="animable"
            id="elas4vkzlgk7e"
          />
        </g>
      </g>
      <path
        d="M239.14,407.37a3.57,3.57,0,0,1,4.1-1,3.67,3.67,0,0,1,4.06-.28c2,1.32,6,16.32,2.11,19.13-1.12.8-4.25,1.55-5.21-.06a2.37,2.37,0,0,1-3.65-1.15c-1.12-2.61.93-5.82-2-13.39A3.19,3.19,0,0,1,239.14,407.37Z"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "244.694px 415.859px",
        }}
        id="el641ec3oscle"
        className="animable"
      />
      <path
        d="M245.46,415.16a25.16,25.16,0,0,1,.08,7"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "245.603px 418.66px",
        }}
        id="elnkl73tf3umf"
        className="animable"
      />
      <path
        d="M258,370.25a1.95,1.95,0,1,1-1.84-2.05A2,2,0,0,1,258,370.25Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "256.052px 370.147px",
        }}
        id="eljl1zszxivaj"
        className="animable"
      />
      <path
        d="M256.56,400.45a1.94,1.94,0,1,1-1.83-2.06A1.95,1.95,0,0,1,256.56,400.45Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "254.624px 400.327px",
        }}
        id="el1lqm130mfed"
        className="animable"
      />
      <path
        d="M274.42,333.27,273,313.12,252.14,318,251,334.13c-1.31.16-2.56.35-3.79.53l5.1,12.23,10,1.31,15.94-14.69C277,333.41,275.68,333.33,274.42,333.27Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "262.73px 330.66px",
        }}
        id="elj787sly67zb"
        className="animable"
      />
      <g
        style={{
          clipPath: "url(&quot",
          transformOrigin: "262.595px 323.503px",
        }}
        id="el3i256ozwwcy"
        className="animable"
      >
        <path
          d="M251.83,325.08c.14,14.34,16.89,9.94,21.53-4.38l-.37-7.58L252.14,318Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "262.595px 323.503px",
          }}
          id="elo0enz3azbkd"
          className="animable"
        />
      </g>
      <path
        d="M274.42,333.27,273,313.12,252.14,318,251,334.13c-1.31.16-2.56.35-3.79.53l5.1,12.23,10,1.31,15.94-14.69C277,333.41,275.68,333.33,274.42,333.27Z"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "262.73px 330.66px",
        }}
        id="elij2z4rmtcrq"
        className="animable"
      />
      <path
        d="M239.06,296.11s-7.62-13.18-8.74-20.13c-3.49-21.47,12-14.23,12-14.23s11-9.81,24.61-8.09,17.25,7.53,26.44,11.1c0,0-6.9,35-15.73,42.86S239.06,296.11,239.06,296.11Z"
        style={{
          fill: "rgb(38, 50, 56)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "261.589px 281.477px",
        }}
        id="el8ybc5kiirdw"
        className="animable"
      />
      <path
        d="M243.07,264.94s-3.43-8.34,5.27-14.71"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "245.372px 257.585px",
        }}
        id="eloeal8o5pg3r"
        className="animable"
      />
      <path
        d="M258.05,259.93c10.19-4.5,14.74,3,26.11,5"
        style={{
          fill: "none",
          stroke: "rgb(191, 191, 191)",
          strokeMiterlimit: 10,
          transformOrigin: "271.105px 261.723px",
        }}
        id="elajlon75y9di"
        className="animable"
      />
      <path
        d="M250.18,264.94a13,13,0,0,1,3.31-2.95"
        style={{
          fill: "none",
          stroke: "rgb(191, 191, 191)",
          strokeMiterlimit: 10,
          transformOrigin: "251.835px 263.465px",
        }}
        id="elzaydev9g0t"
        className="animable"
      />
      <path
        d="M260.64,268.21s4.41-4.23,13.16,1.27a22.84,22.84,0,0,0,8.73,3.44"
        style={{
          fill: "none",
          stroke: "rgb(191, 191, 191)",
          strokeMiterlimit: 10,
          transformOrigin: "271.585px 269.788px",
        }}
        id="eli8c8ff496h"
        className="animable"
      />
      <path
        d="M274.12,277.37c-12.68.33-25.78-5.4-25.78-5.4-11.82,7.13-10.06,18.72-10.06,18.72,2.7,27.7,6.35,35.08,19.29,35.08s23.46-14,24.31-33.95C277,292.05,274.12,277.37,274.12,277.37Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "260.034px 298.87px",
        }}
        id="elco9i5qolovs"
        className="animable"
      />
      <path
        d="M280.79,290.69a3.35,3.35,0,0,1,2.6-1.47c2.3,0,4,3,3.19,6.75s-1.87,6.74-4.17,6.74a2.59,2.59,0,0,1-2.36-1.76"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "283.417px 295.965px",
        }}
        id="elq8q27eii52a"
        className="animable"
      />
      <path
        d="M255.58,304.29s1.55,2.12-1.42,3.71-5.33,1.56-6.09-.26,2.54-17,2.54-17"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "251.97px 299.946px",
        }}
        id="eli58x5areuts"
        className="animable"
      />
      <path
        d="M250.11,293.17c-1.6-.81-8-3.61-14.08.21l.39,5.88s2.24,1.23,7.38,1.23a20.65,20.65,0,0,0,5-.52"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "243.07px 295.957px",
        }}
        id="elv7hclsrdz3"
        className="animable"
      />
      <path
        d="M255.42,293.38l1.86,6.13s.76,1,5.91,1,6.84-1.23,6.84-1.23l-.15-5.88S262.41,289,255.42,293.38Z"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "262.725px 295.974px",
        }}
        id="el9lnmh3b03jg"
        className="animable"
      />
      <line
        x1={250.52}
        y1={293.38}
        x2={255.42}
        y2={293.38}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "252.97px 293.38px",
        }}
        id="ela4w7xvv1b1r"
        className="animable"
      />
      <path
        d="M251.56,313.56a13.44,13.44,0,0,0,8.15-.25,11.3,11.3,0,0,0,5.07-3.82"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "258.17px 311.782px",
        }}
        id="elzf9pahd5q7"
        className="animable"
      />
      <path
        d="M259.71,287.58c6.43-2.65,9.27.53,9.27.53"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "264.345px 287.318px",
        }}
        id="el86dn7jyj5oc"
        className="animable"
      />
      <path
        d="M242.74,287.32a6.51,6.51,0,0,1,6.88.79"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "246.18px 287.396px",
        }}
        id="elvmacoyada8r"
        className="animable"
      />
      <path
        d="M262.27,292.05c.6,0,1,1,1,2.17s-.5,2.16-1.08,2.16-1-1-1-2.16S261.68,292.05,262.27,292.05Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "262.23px 294.215px",
        }}
        id="elfeihahfgng9"
        className="animable"
      />
      <path
        d="M246.3,291.78c.59,0,1,1,1,2.17s-.5,2.16-1.08,2.16-1-1-1-2.16S245.72,291.78,246.3,291.78Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "246.26px 293.945px",
        }}
        id="el3dbbg6kbhjf"
        className="animable"
      />
      <path
        d="M235.64,280.74a16.35,16.35,0,0,0,1,3.44"
        style={{
          fill: "none",
          stroke: "rgb(191, 191, 191)",
          strokeMiterlimit: 10,
          transformOrigin: "236.14px 282.46px",
        }}
        id="eluf8f9eob4u"
        className="animable"
      />
      <path
        d="M243.31,267.53c-6.32-1.7-8.82,2.1-8.35,8.1"
        style={{
          fill: "none",
          stroke: "rgb(191, 191, 191)",
          strokeMiterlimit: 10,
          transformOrigin: "239.107px 271.376px",
        }}
        id="el9jocvdcyt88"
        className="animable"
      />
      <path
        d="M250,333.19l7.7,13.86,18.49-14.59,5.69.8-12,21.15a1.63,1.63,0,0,1-2.28.57l-10.23-6.46-8,4.88a1.63,1.63,0,0,1-2.47-1.21l-2-18.06Z"
        style={{
          fill: "#E32531",
          transformOrigin: "263.39px 343.845px",
        }}
        id="elvh8jje0rgao"
        className="animable"
      />
      <g
        style={{
          clipPath: "url(&quot",
          transformOrigin: "263.555px 343.715px",
        }}
        id="el7lynzq3vcho"
        className="animable"
      >
        <g id="elc09y0n505qh">
          <path
            d="M249.32,333.1l8.38,13.95,18.82-14.85,5.66.9-12.27,21.31a1.63,1.63,0,0,1-2.28.57l-10.23-6.46-8,4.88a1.63,1.63,0,0,1-2.47-1.21l-2-18.06Z"
            style={{
              opacity: 0.3,
              transformOrigin: "263.555px 343.715px",
            }}
            className="animable"
            id="el8s577asaydh"
          />
        </g>
      </g>
      <path
        d="M250,333.19l7.7,13.86,18.49-14.59,5.69.8-12,21.15a1.63,1.63,0,0,1-2.28.57l-10.23-6.46-8,4.88a1.63,1.63,0,0,1-2.47-1.21l-2-18.06Z"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "263.39px 343.845px",
        }}
        id="elrcg4pz46hlc"
        className="animable"
      />
      <path
        d="M135.35,424.23h50.28a0,0,0,0,1,0,0v6.7a0,0,0,0,1,0,0H135.35a2,2,0,0,1-2-2V426.2A2,2,0,0,1,135.35,424.23Z"
        style={{
          fill: "rgb(38, 50, 56)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "159.49px 427.58px",
        }}
        id="ellvsm5gwiz6d"
        className="animable"
      />
      <path
        d="M228.89,430.93H185.63v-6.7L229,427.08a1.38,1.38,0,0,1,1.28,1.37v1.11A1.37,1.37,0,0,1,228.89,430.93Z"
        style={{
          fill: "#E32531",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "207.955px 427.58px",
        }}
        id="el5tfr88uuxfj"
        className="animable"
      />
      <path
        d="M269.91,294.37l10.88-3.68-1.29,1.63"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "275.35px 292.53px",
        }}
        id="elbm3yc6eapt"
        className="animable"
      />
    </g>
    <g
      id="freepik--character-2--inject-392"
      className="animable"
      style={{
        transformOrigin: "337.992px 348.364px",
      }}
    >
      <path
        d="M339.6,306.89s-12.53-38.26,19-40.94,35.22,26.68,38.11,41.4c2.26,11.51,23.78,32.56,7.12,48.27-17.38,16.41-59.72,10.93-62.16-12.39S341.44,315.13,339.6,306.89Z"
        style={{
          fill: "rgb(38, 50, 56)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "373.625px 315.425px",
        }}
        id="eldbo7s3000xj"
        className="animable"
      />
      <path
        d="M376.36,313s-1.37,17,7.38,31.55c0,0-11.79,3.85-24.09.19h0a40.46,40.46,0,0,0-.74-13.48l-.42-1.85,8.94-7.73Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "371.115px 329.659px",
        }}
        id="eluh0wpw6ih9"
        className="animable"
      />
      <g
        style={{
          clipPath: "url(&quot",
          transformOrigin: "365.6px 323.218px",
        }}
        id="el37tdlriditb"
        className="animable"
      >
        <path
          d="M354.72,325.77c1.63,9.13,3.12,11.12,10.86,9.49,5.73-1.21,10.62-9.81,10.9-16.06a84.16,84.16,0,0,1-.41-8.54l-8.64,11Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "365.6px 323.218px",
          }}
          id="el9wzsqhj47vh"
          className="animable"
        />
      </g>
      <path
        d="M376.36,313s-1.37,17,7.38,31.55c0,0-11.79,3.85-24.09.19h0a40.46,40.46,0,0,0-.74-13.48l-.42-1.85,8.94-7.73Z"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "371.115px 329.659px",
        }}
        id="elv3wbaob6m2"
        className="animable"
      />
      <path
        d="M288.63,410.07s-17.45-8-18.43-1.38,3.29,16.84,19.27,11.81L323,424.92s5.74-11.43-.39-17.66C322.6,407.26,293.06,411.85,288.63,410.07Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "297.754px 415.494px",
        }}
        id="elvjt0xqh4vwi"
        className="animable"
      />
      <path
        d="M261.74,417.23s-2.76.89-3.17,2.72-1.3,4.42-.24,4.43,2.35-3.64,2.35-3.64l2.69-.7Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "260.6px 420.805px",
        }}
        id="ellst1ay1u6i"
        className="animable"
      />
      <g id="elry4y1q49we">
        <rect
          x={263.18}
          y={400.74}
          width={18.24}
          height={25.98}
          style={{
            fill: "rgb(255, 255, 255)",
            stroke: "rgb(38, 50, 56)",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            transformOrigin: "272.3px 413.73px",
            transform: "rotate(-5.98deg)",
          }}
          className="animable"
          id="elumg20dck4za"
        />
      </g>
      <g id="elrtjjavyxi7">
        <rect
          x={260.51}
          y={401.83}
          width={2.72}
          height={25.98}
          style={{
            fill: "#E32531",
            stroke: "rgb(38, 50, 56)",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            transformOrigin: "261.87px 414.82px",
            transform: "rotate(-5.98deg)",
          }}
          className="animable"
          id="eles9hjassmfq"
        />
      </g>
      <path
        d="M275.14,396.12a4,4,0,0,0-3.52,4.34,2.61,2.61,0,0,0,.06.27l.91-.09,1-.1a2.33,2.33,0,0,1-.05-.28,2.05,2.05,0,1,1,3.24,1.44,1.8,1.8,0,0,0,1.53,1.18,3.94,3.94,0,0,0-3.14-6.76Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "275.562px 399.489px",
        }}
        id="eltfp6ygz6wu"
        className="animable"
      />
      <line
        x1={265.29}
        y1={407.12}
        x2={271.54}
        y2={406.46}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "268.415px 406.79px",
        }}
        id="elg47hsbccz07"
        className="animable"
      />
      <line
        x1={265.59}
        y1={409.96}
        x2={277.72}
        y2={408.69}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "271.655px 409.325px",
        }}
        id="elb8pcjvh5qt"
        className="animable"
      />
      <line
        x1={265.89}
        y1={412.81}
        x2={271.96}
        y2={412.18}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "268.925px 412.495px",
        }}
        id="elkqdz5i2j7s"
        className="animable"
      />
      <line
        x1={266.19}
        y1={415.66}
        x2={276.32}
        y2={414.6}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "271.255px 415.13px",
        }}
        id="el3t0a0v3o5gp"
        className="animable"
      />
      <line
        x1={266.49}
        y1={418.51}
        x2={272.55}
        y2={417.87}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "269.52px 418.19px",
        }}
        id="elf2swt3hy6zb"
        className="animable"
      />
      <line
        x1={266.79}
        y1={421.35}
        x2={280.09}
        y2={419.96}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "273.44px 420.655px",
        }}
        id="el0lz37mtr8bi"
        className="animable"
      />
      <line
        x1={267.08}
        y1={424.2}
        x2={273.33}
        y2={423.55}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "270.205px 423.875px",
        }}
        id="ell3p6vb0ffe9"
        className="animable"
      />
      <path
        d="M271.78,396.47a4,4,0,0,0-3.51,4.34,2.74,2.74,0,0,0,.05.28l.92-.1h0l1-.1a1.27,1.27,0,0,1-.06-.28,2.06,2.06,0,0,1,4.09-.42,2,2,0,0,1-.85,1.86,1.8,1.8,0,0,0,1.53,1.18,3.94,3.94,0,0,0-3.14-6.76Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "272.207px 399.839px",
        }}
        id="el92104md8qek"
        className="animable"
      />
      <path
        d="M268.42,396.82a4,4,0,0,0-3.51,4.34c0,.1,0,.18,0,.28l.92-.1,1-.1a2.61,2.61,0,0,1-.06-.27,2.06,2.06,0,1,1,3.25,1.44,1.76,1.76,0,0,0,1.52,1.17,3.87,3.87,0,0,0,1.2-3.24A4,4,0,0,0,268.42,396.82Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "268.828px 400.192px",
        }}
        id="el13p8lgdbmfvg"
        className="animable"
      />
      <path
        d="M265.07,397.17a4,4,0,0,0-3.52,4.34,2.3,2.3,0,0,0,.06.28l.91-.1,1-.1a2.56,2.56,0,0,1-.05-.27,2.05,2.05,0,1,1,3.24,1.44,1.79,1.79,0,0,0,1.53,1.17,3.93,3.93,0,0,0,1.2-3.24A4,4,0,0,0,265.07,397.17Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "265.496px 400.54px",
        }}
        id="elaq4zn0aqes9"
        className="animable"
      />
      <path
        d="M260.08,401.67a2.06,2.06,0,1,1,3.24,1.44,1.79,1.79,0,0,0,1.53,1.17,3.94,3.94,0,1,0-5.45,0l-.23-2.25,1-.1A1.31,1.31,0,0,1,260.08,401.67Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "262.125px 400.887px",
        }}
        id="elljjoeicnwcl"
        className="animable"
      />
      <path
        d="M257.07,409a8.51,8.51,0,0,0,.59,1.09,4.77,4.77,0,0,0,.72,4.07s.08,2.85,1.09,3.3,2.62,1,2.59.2-.5-3.19-2.32-3.72c0,0,2.09.41,1.86-.75s-.63-2.84-1.91-3.32l-.69-.3s1.66.3,1.52-.95-.28-2.72-1.23-3.07c-.22-.08-.47-.15-.73-.22C257.16,405,256.26,407.2,257.07,409Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "259.412px 411.682px",
        }}
        id="ellyj2eacwsmq"
        className="animable"
      />
      <path
        d="M286.67,409.85s-1.95-4.32-5.14-6.57-4.39-6.63-5.69-5.57-.12,5.71,1.9,7.3-.24,5.14,4.73,9.52"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "280.982px 406.039px",
        }}
        id="elayo3r8mfje"
        className="animable"
      />
      <path
        d="M404.14,422.46q-.66,4.08-1.41,8.47H334.15c-.11-.92.54-2.77,1.16-6-7.64,2.59-21-1.43-21-1.43,1.66-4.37.51-15.47.51-15.47l7.78-1.65s3.23-33.82,5.69-43.51c2.61-10.28,16.89-21.5,64.92-18.19h0s22.16-.42,25.6,14.27C422.05,372.66,405.06,421.83,404.14,422.46Z"
        style={{
          fill: "#E32531",
          transformOrigin: "366.765px 387.51px",
        }}
        id="el2ztfcpyp30m"
        className="animable"
      />
      <g
        style={{
          clipPath: "url(&quot",
          transformOrigin: "360.83px 397.355px",
        }}
        id="elg1836g3g67u"
        className="animable"
      >
        <g id="ela7rzfepjen8">
          <path
            d="M335.31,424.94c-5.31,1.8-13.36.41-17.78-.61,1.15-.88,1.87-2.68,2.14-5,3.6-.56,7.2-6.28,9.57-32.28.56-6.1,1.76-9.93,3.3-12.51a36.23,36.23,0,0,0-.18,17.88c.86,3.49,3.56,11.89,3.8,15.37A64.67,64.67,0,0,1,335.31,424.94Z"
            style={{
              opacity: 0.2,
              transformOrigin: "326.958px 400.175px",
            }}
            className="animable"
            id="el6f5bebumbfa"
          />
        </g>
        <g id="elpqgljmg7ma">
          <path
            d="M404.13,422.47q-.64,4.08-1.4,8.46H334.15c1.23-3.76,4.25-21.66,0-32.54-.17-.44,14.73-6.7,24.71-4.14,42.3,10.85,27.73-24.11,39.81-30.47l-10.42,40.87-5.69,1.81c12.32.76,8.76,19.23,8.76,19.23A17.88,17.88,0,0,0,404.13,422.47Z"
            style={{
              opacity: 0.2,
              transformOrigin: "369.139px 397.355px",
            }}
            className="animable"
            id="el2zzdpeb33ij"
          />
        </g>
      </g>
      <path
        d="M404.14,422.46q-.66,4.08-1.41,8.47H334.15c-.11-.92.54-2.77,1.16-6-7.64,2.59-21-1.43-21-1.43,1.66-4.37.51-15.47.51-15.47l7.78-1.65s3.23-33.82,5.69-43.51c2.61-10.28,16.89-21.5,64.92-18.19h0s22.16-.42,25.6,14.27C422.05,372.66,405.06,421.83,404.14,422.46Z"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "366.765px 387.51px",
        }}
        id="elvzxv8vjo4x"
        className="animable"
      />
      <path
        d="M316.1,406.13s2.6,1.39,3.45,7.5-.46,11.37-3.85,11.29-4-1.41-3.3-2.67,2.18-2.95,1.05-8.18c-1.42-6.55-4.34-5.95-4.34-5.95S313,404.39,316.1,406.13Z"
        style={{
          fill: "#E32531",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "314.456px 415.294px",
        }}
        id="elxyzd6loqsae"
        className="animable"
      />
      <g id="elqw2dtp9h8b">
        <path
          d="M319.67,419.37c-.27,2.28-1,4.08-2.14,5a2.79,2.79,0,0,1-1.83.59c-3.4-.08-4-1.41-3.3-2.67s2.18-2.95,1.05-8.18c-1.42-6.55-4.34-5.95-4.34-5.95s3.9-3.73,7-2c0,0,2.6,1.39,3.45,7.5A23.3,23.3,0,0,1,319.67,419.37Z"
          style={{
            opacity: 0.2,
            transformOrigin: "314.452px 415.332px",
          }}
          className="animable"
          id="el18ozkghhyvm"
        />
      </g>
      <path
        d="M381.43,332.46s-17.24,5.23-25.08,2.44l-1.63,10.47s7.63,6.64,32.07-1.53Z"
        style={{
          fill: "#E32531",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "370.755px 340.188px",
        }}
        id="el2dqadyt92w9"
        className="animable"
      />
      <path
        d="M320.17,403.08c2.05,6.67,3.88,12,2.07,12.59s-3.3-4.91-5.35-11.59-3.88-12-2.07-12.58S318.12,396.4,320.17,403.08Z"
        style={{
          fill: "#E32531",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "318.53px 403.586px",
        }}
        id="elw9sc9xd9q5a"
        className="animable"
      />
      <path
        d="M316.63,403.24l3.28-1c-.48-1.57-.93-3.07-1.36-4.41l-3.27,1C315.68,400.18,316.14,401.66,316.63,403.24Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "317.595px 400.535px",
        }}
        id="elgin43t88or"
        className="animable"
      />
      <path
        d="M316.33,394.66s1.53-3.07,2.94-.9,1.7,8.76,2.7,8.77"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "319.15px 397.757px",
        }}
        id="elutojpn48pk9"
        className="animable"
      />
      <path
        d="M336.67,362c-1.25,3.83-3,8-4.13,12.59a36.23,36.23,0,0,0-.18,17.88c.86,3.49,3.56,11.89,3.8,15.37a64.67,64.67,0,0,1-.85,17.11c-.62,3.22-1.27,5.07-1.16,6"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "333.999px 396.475px",
        }}
        id="elbuq05b67b56"
        className="animable"
      />
      <path
        d="M379.12,407.6s-27.9,3.81-37.31,4c-1.44,0-5.76-.5-5.76-.5l-6.69-4.47s-5.15-.76-7.68-.19l-2.88,3.77s-3.59,1.16-1.54,3.88a3.48,3.48,0,0,0,.95,3.67s.16,2.37,1.74,3.32c0,0,.31,2.21,2.05,2.84s12.63-1.11,15.95-2.05,35.52,4.1,48.15,3.79C386.1,425.68,396.92,413,379.12,407.6Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "352.992px 415.951px",
        }}
        id="eljlq3kxl56d"
        className="animable"
      />
      <path
        d="M379.55,302s-7.36,2.87-11.72-5.07c-1.89-3.44-5.71-10.61-5.71-10.61-1.09,2.81.25,7.09.25,7.09-2.5-1.09-7.32-1.35-7.32-1.35-1.71-2.86-2.21-9.36-2.21-9.36-2.37,4-1.69,9.64-1.69,9.64a19,19,0,0,0-10.49,4.44c.63,2.55.85,6.53.64,14.8-.27,10.79,4.92,13.75,10,17.79s18.91,6.12,23.69-15c0,0,10-3.73,5.12-11.56Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "361.056px 307.341px",
        }}
        id="elop3spvejd9l"
        className="animable"
      />
      <path
        d="M371.35,289A24.41,24.41,0,0,0,387,302.27"
        style={{
          fill: "none",
          stroke: "rgb(191, 191, 191)",
          strokeMiterlimit: 10,
          transformOrigin: "379.175px 295.635px",
        }}
        id="el9mf0fy985t"
        className="animable"
      />
      <path
        d="M368.72,281a26.08,26.08,0,0,0,1,3.87"
        style={{
          fill: "none",
          stroke: "rgb(191, 191, 191)",
          strokeMiterlimit: 10,
          transformOrigin: "369.22px 282.935px",
        }}
        id="elvcz1akbq6r"
        className="animable"
      />
      <path
        d="M373.72,281.49s5.68,10.84,14.56,11.1"
        style={{
          fill: "none",
          stroke: "rgb(191, 191, 191)",
          strokeMiterlimit: 10,
          transformOrigin: "381px 287.04px",
        }}
        id="el5fz9f0khflt"
        className="animable"
      />
      <path
        d="M391.13,309.06s14.45,23.4,14.45,37"
        style={{
          fill: "none",
          stroke: "rgb(191, 191, 191)",
          strokeMiterlimit: 10,
          transformOrigin: "398.355px 327.56px",
        }}
        id="elpr81t6daz4k"
        className="animable"
      />
      <path
        d="M387.31,315.3s3.57,13.05,9.32,19.6"
        style={{
          fill: "none",
          stroke: "rgb(191, 191, 191)",
          strokeMiterlimit: 10,
          transformOrigin: "391.97px 325.1px",
        }}
        id="elws4xxmy5qc"
        className="animable"
      />
      <path
        d="M341.9,281.37a38.55,38.55,0,0,0-.85,5.85"
        style={{
          fill: "none",
          stroke: "rgb(191, 191, 191)",
          strokeMiterlimit: 10,
          transformOrigin: "341.475px 284.295px",
        }}
        id="elrhfaskdfeqm"
        className="animable"
      />
      <path
        d="M353.73,269.11s-6.73,1.26-11.12,9.19"
        style={{
          fill: "none",
          stroke: "rgb(191, 191, 191)",
          strokeMiterlimit: 10,
          transformOrigin: "348.17px 273.705px",
        }}
        id="elgp21urjvdx"
        className="animable"
      />
      <path
        d="M345.21,329.7s-.22,10.5,5.14,16.4"
        style={{
          fill: "none",
          stroke: "rgb(191, 191, 191)",
          strokeMiterlimit: 10,
          transformOrigin: "347.779px 337.9px",
        }}
        id="elei2m3cozu8a"
        className="animable"
      />
      <path
        d="M354.72,297.57c7.29-1.43,10.48,2.28,10.48,2.28"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "359.96px 298.546px",
        }}
        id="elfk0ehekrry"
        className="animable"
      />
      <path
        d="M342.58,300.64a8.32,8.32,0,0,1,6.17-2.46"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "345.665px 299.408px",
        }}
        id="elq5zkgyf6rpg"
        className="animable"
      />
      <path
        d="M359.47,322c2.25-1.28,3.5-4.62,3.5-4.62l-.47.26a27.2,27.2,0,0,1-9.43,3h0A5.4,5.4,0,0,0,359.47,322Z"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "358.02px 319.949px",
        }}
        id="elax5w7uv8b4m"
        className="animable"
      />
      <path
        d="M350.55,315.06c-.95-.12-3.66-1.4-3.89-3.24-.07-.55.33-1.05.92-1.49a8.38,8.38,0,0,0,3.55-7.34c0-.2,0-.32,0-.32"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "348.898px 308.865px",
        }}
        id="el6kznl2sg4mq"
        className="animable"
      />
      <path
        d="M359.87,300.5c.69-.09,1.4,1.06,1.58,2.55s-.22,2.76-.92,2.85-1.39-1.06-1.58-2.55S359.18,300.58,359.87,300.5Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "360.199px 303.2px",
        }}
        id="elruj25kxoala"
        className="animable"
      />
      <path
        d="M347.85,304.81c.18,1.46-.22,2.71-.9,2.79s-1.37-1-1.55-2.49.22-2.72.9-2.8S347.67,303.34,347.85,304.81Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "346.625px 304.955px",
        }}
        id="el5nmw0e839xh"
        className="animable"
      />
      <path
        d="M370.23,301.75s-.93-2.64.13-4"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "370.106px 299.75px",
        }}
        id="elmbyqgslavps"
        className="animable"
      />
      <path
        d="M404.13,422.47a17.86,17.86,0,0,1-12.82,3.22s3.56-18.47-8.76-19.23l5.69-1.81,10.42-40.87"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "393.34px 394.814px",
        }}
        id="el5j23vssg8g7"
        className="animable"
      />
      <path
        d="M391.31,404.65s6.6,1.74,8.45,7.42"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "395.535px 408.36px",
        }}
        id="el4rcylmmcv0t"
        className="animable"
      />
      <path
        d="M364.38,338.88a44.8,44.8,0,0,0,18.2-4"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "373.48px 336.88px",
        }}
        id="eltrze44ov8s"
        className="animable"
      />
      <path
        d="M355.88,337.9a27.27,27.27,0,0,0,4.3.76"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "358.03px 338.28px",
        }}
        id="el1l46hdv31iki"
        className="animable"
      />
      <path
        d="M384,349.62q2.67-.94,5.6-2.21"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "386.8px 348.515px",
        }}
        id="elhp7c5bqmzb6"
        className="animable"
      />
      <path
        d="M353.11,349.77s6.71,6.37,24.46,1.82"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "365.34px 351.499px",
        }}
        id="elh3p8ssfuka"
        className="animable"
      />
      <path
        d="M358.91,381.43s1,15.37,12.44,21.1"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "365.13px 391.98px",
        }}
        id="el7b7dksmyc5s"
        className="animable"
      />
      <path
        d="M378.84,407.84s2.24-4.94,8.94-2.5c0,0,6.33,2.18,8.23,8.69s-.48,12.32-5.1,12.56-5.46-.12-4.68-1.54a11.62,11.62,0,0,0,.36-10.12C383.72,408.06,378.84,407.84,378.84,407.84Z"
        style={{
          fill: "#E32531",
          transformOrigin: "387.753px 415.661px",
        }}
        id="elkiwu9doar8"
        className="animable"
      />
      <g
        style={{
          clipPath: "url(&quot",
          transformOrigin: "387.753px 415.661px",
        }}
        id="ely3b21w1t3z"
        className="animable"
      >
        <g id="el2f44fdvicd4">
          <g
            style={{
              opacity: 0.2,
              transformOrigin: "387.753px 415.661px",
            }}
            className="animable"
            id="elvuud6858hpe"
          >
            <path
              d="M378.84,407.84s2.24-4.94,8.94-2.5c0,0,6.33,2.18,8.23,8.69s-.48,12.32-5.1,12.56-5.46-.12-4.68-1.54a11.62,11.62,0,0,0,.36-10.12C383.72,408.06,378.84,407.84,378.84,407.84Z"
              id="elm0ifqjm7a2p"
              className="animable"
              style={{
                transformOrigin: "387.753px 415.661px",
              }}
            />
          </g>
        </g>
      </g>
      <path
        d="M378.84,407.84s2.24-4.94,8.94-2.5c0,0,6.33,2.18,8.23,8.69s-.48,12.32-5.1,12.56-5.46-.12-4.68-1.54a11.62,11.62,0,0,0,.36-10.12C383.72,408.06,378.84,407.84,378.84,407.84Z"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "387.753px 415.661px",
        }}
        id="elxd5undawq7"
        className="animable"
      />
    </g>
    <g
      id="freepik--Desk--inject-392"
      className="animable"
      style={{
        transformOrigin: "238.045px 378.17px",
      }}
    >
      <path
        d="M72.44,387.51S69,358.1,38.59,370c0,0,25.88-.19,30.26,22l4-.43Z"
        style={{
          fill: "#E32531",
          transformOrigin: "55.72px 379.582px",
        }}
        id="eljbdlnbf1cw"
        className="animable"
      />
      <g id="eleiv73an1r0g">
        <path
          d="M72.44,387.51S69,358.1,38.59,370c0,0,25.88-.19,30.26,22l4-.43Z"
          style={{
            opacity: 0.1,
            transformOrigin: "55.72px 379.582px",
          }}
          className="animable"
          id="elvsudno0cst"
        />
      </g>
      <path
        d="M72.86,387s-2.63-31.36-8.36-55.73c0,0,17.5,18.51,13.5,53.36Z"
        style={{
          fill: "#E32531",
          transformOrigin: "71.5472px 359.135px",
        }}
        id="el69f1uo96nf"
        className="animable"
      />
      <g id="el0p7spzc6xuh">
        <path
          d="M72.86,387s-2.63-31.36-8.36-55.73c0,0,17.5,18.51,13.5,53.36Z"
          style={{
            opacity: 0.1,
            transformOrigin: "71.5472px 359.135px",
          }}
          className="animable"
          id="elswdbaqqqby"
        />
      </g>
      <path
        d="M71.16,407.78s-5-43.2-21.83-58c0,0,30,7.47,25.58,53.35Z"
        style={{
          fill: "#E32531",
          transformOrigin: "62.3423px 378.78px",
        }}
        id="elj5hzdwm75gi"
        className="animable"
      />
      <path
        d="M76.44,406s7.35-42.87,24.91-56.78c0,0-30.38,5.84-28.4,51.9Z"
        style={{
          fill: "#E32531",
          transformOrigin: "87.1036px 377.61px",
        }}
        id="elqxxvmp6epr"
        className="animable"
      />
      <path
        d="M91.85,391.94H56.35v6.17h1.18v21.77a11.05,11.05,0,0,0,11,11.05h11a11.06,11.06,0,0,0,11.06-11.05V398.11h1.18Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeMiterlimit: 10,
          transformOrigin: "74.1px 411.435px",
        }}
        id="elvcj2sbbebdf"
        className="animable"
      />
      <path
        d="M80.85,397.82h4.72"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeMiterlimit: 10,
          transformOrigin: "83.21px 397.82px",
        }}
        id="el06pwhwg1ec32"
        className="animable"
      />
      <path
        d="M62.34,397.82H76"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeMiterlimit: 10,
          transformOrigin: "69.17px 397.82px",
        }}
        id="elosllfc3a8ar"
        className="animable"
      />
      <path
        d="M212,403.77l-9.1-74.1a5,5,0,0,0-4.79-4.26H187.69L199.75,408h8.53A3.69,3.69,0,0,0,212,403.77Z"
        style={{
          fill: "#E32531",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "199.865px 366.705px",
        }}
        id="el7trfrjeam9t"
        className="animable"
      />
      <path
        d="M206,408H101.16a5,5,0,0,1-4.78-4.26l-9.1-74.1A3.68,3.68,0,0,1,91,325.41H195.88a5,5,0,0,1,4.78,4.26l9.1,74.1A3.69,3.69,0,0,1,206,408Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "148.519px 366.705px",
        }}
        id="elubupuszqtlf"
        className="animable"
      />
      <g
        style={{
          clipPath: "url(&quot",
          transformOrigin: "148.519px 366.705px",
        }}
        id="elc6jszf43ion"
        className="animable"
      >
        <g id="el6bj7xfks8z7">
          <path
            d="M206,408H101.16a5,5,0,0,1-4.78-4.26l-9.1-74.1A3.68,3.68,0,0,1,91,325.41H195.88a5,5,0,0,1,4.78,4.26l9.1,74.1A3.69,3.69,0,0,1,206,408Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.1,
              transformOrigin: "148.519px 366.705px",
            }}
            className="animable"
            id="el5xu6s0n0lrh"
          />
        </g>
      </g>
      <path
        d="M206,408H101.16a5,5,0,0,1-4.78-4.26l-9.1-74.1A3.68,3.68,0,0,1,91,325.41H195.88a5,5,0,0,1,4.78,4.26l9.1,74.1A3.69,3.69,0,0,1,206,408Z"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "148.519px 366.705px",
        }}
        id="elpxp4kbp72ub"
        className="animable"
      />
      <path
        d="M157.13,424.87l4.19-47.73a2,2,0,0,0-2-2.13H132.89a2,2,0,0,0-2,1.79l-4.56,52a2,2,0,0,0,2,2.13h52.44a2,2,0,0,0,2-2h0a2,2,0,0,0-2-2H159.08A2,2,0,0,1,157.13,424.87Z"
        style={{
          fill: "rgb(38, 50, 56)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "154.548px 402.97px",
        }}
        id="el0b7ypx953i5"
        className="animable"
      />
      <path
        d="M182.73,429a2,2,0,0,0-2-2H159.08a2,2,0,0,1-2-2.14l4.19-47.73a2,2,0,1,0-3.9-.34l-4.56,52a2,2,0,0,0,1.95,2.13h26A2,2,0,0,0,182.73,429Z"
        style={{
          fill: "#E32531",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "167.768px 402.735px",
        }}
        id="elqqbdg4gm4cc"
        className="animable"
      />
      <line
        x1={62.5}
        y1={430.93}
        x2={437.5}
        y2={430.93}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "250px 430.93px",
        }}
        id="elmi0w23c5rt"
        className="animable"
      />
    </g>
    <g
      id="freepik--Code--inject-392"
      className="animable animator-hidden"
      style={{
        transformOrigin: "368.94px 249.02px",
      }}
    >
      <path
        d="M412.41,249.33H392.7a4.63,4.63,0,0,0-4.63,4.63v9.6a4.63,4.63,0,0,0,4.63,4.63h5.15l1.51,8.85,7.9-8.85h5.15a4.63,4.63,0,0,0,4.64-4.63V254A4.64,4.64,0,0,0,412.41,249.33Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "402.56px 263.185px",
        }}
        id="elnoe6wsz5dkk"
        className="animable"
      />
      <path
        d="M382.19,221H362.48a4.63,4.63,0,0,0-4.64,4.63v9.59a4.64,4.64,0,0,0,4.64,4.64h5.15l3.91,8.85,5.5-8.85h5.15a4.64,4.64,0,0,0,4.64-4.64v-9.59A4.63,4.63,0,0,0,382.19,221Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "372.335px 234.855px",
        }}
        id="elnri6fw296qj"
        className="animable"
      />
      <path
        d="M343.83,230.91H325.21a4.38,4.38,0,0,0-4.38,4.38v9.06a4.38,4.38,0,0,0,4.38,4.38h4.87l5.08,8.35,3.8-8.35h4.87a4.38,4.38,0,0,0,4.38-4.38v-9.06A4.38,4.38,0,0,0,343.83,230.91Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "334.52px 243.995px",
        }}
        id="elpyutulfzns8"
        className="animable"
      />
      <path
        d="M332,237.68v1.09c0,1.34-.64,2.07-2,2.07h-.63V244h-1.32v-8.4H330C331.33,235.6,332,236.33,332,237.68Zm-2.59-.88v2.84H330c.42,0,.64-.19.64-.79v-1.26c0-.6-.22-.79-.64-.79Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "330.025px 239.8px",
        }}
        id="eln25w0i8itcg"
        className="animable"
      />
      <path
        d="M334,244h-1.32v-8.4H334v3.6h1.5v-3.6h1.34V244h-1.34v-3.6H334Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "334.76px 239.8px",
        }}
        id="el64nzsj7hpqv"
        className="animable"
      />
      <path
        d="M341.68,237.68v1.09c0,1.34-.64,2.07-2,2.07h-.62V244h-1.32v-8.4h1.94C341,235.6,341.68,236.33,341.68,237.68Zm-2.59-.88v2.84h.62c.42,0,.65-.19.65-.79v-1.26c0-.6-.23-.79-.65-.79Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "339.71px 239.8px",
        }}
        id="elbsfekipi7c6"
        className="animable"
      />
      <path
        d="M369.51,231.68v1.12c0,1.34-.67,2.11-2,2.11s-2-.77-2-2.11v-4.37c0-1.34.67-2.11,2-2.11s2,.77,2,2.11v.82h-1.25v-.9c0-.6-.26-.83-.68-.83s-.68.23-.68.83v4.53c0,.6.26.82.68.82s.68-.22.68-.82v-1.2Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "367.51px 230.615px",
        }}
        id="elmp83xim7kr"
        className="animable"
      />
      <path
        d="M372.68,230.15h1.61v.93h-1.61v1.65h-.94v-1.65h-1.6v-.93h1.6v-1.62h.94Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "372.215px 230.63px",
        }}
        id="elw8u1udmn8wj"
        className="animable"
      />
      <path
        d="M377.43,230.15H379v.93h-1.61v1.65h-.93v-1.65h-1.61v-.93h1.61v-1.62h.93Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "376.925px 230.63px",
        }}
        id="el8zxmsto9f5o"
        className="animable"
      />
      <path
        d="M393.31,259.68V258.4l5.35-2v1.3L395,259l3.67,1.31v1.3Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "395.99px 259.005px",
        }}
        id="el60b5rv4ixbr"
        className="animable"
      />
      <path
        d="M403.92,253.3h1.55L401,264.78h-1.56Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "402.455px 259.04px",
        }}
        id="elxean81wjb5"
        className="animable"
      />
      <path
        d="M406.21,261.65v-1.3l3.67-1.31-3.67-1.31v-1.3l5.35,2v1.28Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "408.885px 259.04px",
        }}
        id="elz78tvms442f"
        className="animable"
      />
    </g>
    <defs>
      <clipPath id="freepik--clip-path--inject-392">
        <path
          d="M307.85,412.39c-.74,5.69-1.58,11.85-2.54,18.54H219.47l.41-11.06c-5.13,1.24-15.1.48-15.1.48V404c6.06-3.43,7-2.47,7-2.47s.31-39.9,3.94-49.86a20.09,20.09,0,0,1,7.1-9.34h0a24.31,24.31,0,0,1,2.71-1.75l.13-.08c1-.53,2.21-1.09,3.59-1.67l.38-.15c13.44-5.49,42.77-11.86,70.1-.18,1.91.82,17.51,8.27,18.84,19C319.29,363.67,315.11,394.21,307.85,412.39Z"
          style={{
            fill: "#92E3A9",
            stroke: "#263238",
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
        />
      </clipPath>
      <clipPath id="freepik--clip-path-2--inject-392">
        <path
          d="M239.14,407.37a3.57,3.57,0,0,1,4.1-1,3.67,3.67,0,0,1,4.06-.28c2,1.32,6,16.32,2.11,19.13-1.12.8-4.25,1.55-5.21-.06a2.37,2.37,0,0,1-3.65-1.15c-1.12-2.61.93-5.82-2-13.39A3.19,3.19,0,0,1,239.14,407.37Z"
          style={{
            fill: "#92E3A9",
            stroke: "#263238",
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
        />
      </clipPath>
      <clipPath id="freepik--clip-path-3--inject-392">
        <path
          d="M274.42,333.27,273,313.12,252.14,318,251,334.13c-1.31.16-2.56.35-3.79.53l5.1,12.23,10,1.31,15.94-14.69C277,333.41,275.68,333.33,274.42,333.27Z"
          style={{
            fill: "#fff",
            stroke: "#263238",
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
        />
      </clipPath>
      <clipPath id="freepik--clip-path-4--inject-392">
        <path
          d="M250,333.19l7.7,13.86,18.49-14.59,5.69.8-12,21.15a1.63,1.63,0,0,1-2.28.57l-10.23-6.46-8,4.88a1.63,1.63,0,0,1-2.47-1.21l-2-18.06Z"
          style={{
            fill: "#92E3A9",
            stroke: "#263238",
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
        />
      </clipPath>
      <clipPath id="freepik--clip-path-5--inject-392">
        <path
          d="M376.36,313s-1.37,17,7.38,31.55c0,0-11.79,3.85-24.09.19h0a40.46,40.46,0,0,0-.74-13.48l-.42-1.85,8.94-7.73Z"
          style={{
            fill: "#fff",
            stroke: "#263238",
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
        />
      </clipPath>
      <clipPath id="freepik--clip-path-6--inject-392">
        <path
          d="M404.14,422.46q-.66,4.08-1.41,8.47H334.15c-.11-.92.54-2.77,1.16-6-7.64,2.59-21-1.43-21-1.43,1.66-4.37.51-15.47.51-15.47l7.78-1.65s3.23-33.82,5.69-43.51c2.61-10.28,16.89-21.5,64.92-18.19h0s22.16-.42,25.6,14.27C422.05,372.66,405.06,421.83,404.14,422.46Z"
          style={{
            fill: "#92E3A9",
            stroke: "#263238",
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
        />
      </clipPath>
      <clipPath id="freepik--clip-path-7--inject-392">
        <path
          d="M378.84,407.84s2.24-4.94,8.94-2.5c0,0,6.33,2.18,8.23,8.69s-.48,12.32-5.1,12.56-5.46-.12-4.68-1.54a11.62,11.62,0,0,0,.36-10.12C383.72,408.06,378.84,407.84,378.84,407.84Z"
          style={{
            fill: "#92E3A9",
            stroke: "#263238",
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
        />
      </clipPath>
      <clipPath id="freepik--clip-path-8--inject-392">
        <path
          d="M206,408H101.16a5,5,0,0,1-4.78-4.26l-9.1-74.1A3.68,3.68,0,0,1,91,325.41H195.88a5,5,0,0,1,4.78,4.26l9.1,74.1A3.69,3.69,0,0,1,206,408Z"
          style={{
            fill: "#263238",
            stroke: "#263238",
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
        />
      </clipPath>
    </defs>
    <defs>
      <filter id="active" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter id="hover" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#ff0000" floodOpacity={0.5} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
        <feColorMatrix
          type="matrix"
          values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
        />
      </filter>
    </defs>
  </svg>
);
export default SvgProgramming;
